import { Inject, Injectable, PLATFORM_ID, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UrlUtility } from './url.utility';

@Injectable({ providedIn: 'root' })
export class CanonicalService {
  private renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    rendererFactory: RendererFactory2,
    private urlUtility: UrlUtility
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * Sets a <link rel="canonical"> in the <head>.
   * Removes any existing canonical link first to prevent duplicates.
   * Uses Renderer2 for SSR safety.
   * Automatically normalizes the URL.
   * @param url The canonical URL for the current page
   */
  setCanonicalUrl(url: string): void {
    // Normalize the URL first
    const normalizedUrl = this.urlUtility.normalize(url);

    // Validate the URL
    this.urlUtility.logValidation(normalizedUrl, 'Canonical');

    // Remove existing canonical link using Renderer2 (SSR-safe)
    const existing = this.document.querySelector('link[rel="canonical"]');
    if (existing && existing.parentNode) {
      this.renderer.removeChild(existing.parentNode, existing);
    }

    // Create and append the new canonical link
    const link = this.renderer.createElement('link');
    this.renderer.setAttribute(link, 'rel', 'canonical');
    this.renderer.setAttribute(link, 'href', normalizedUrl);
    this.renderer.appendChild(this.document.head, link);
  }
}

